import styled from 'styled-components';
import { Map } from 'react-leaflet';

export const StyledMap = styled(Map)`
  height: 100%;
`;

export default StyledMap;
